<div [@routerTransition]>
    <sub-header [title]="('SalesInvoices' | localize) + ' ' + ('Details' | localize)"
                [breadcrumbs]="breadcrumbs"></sub-header>

    <div [class]="containerClass">
        <div class="card card-custom gutter-b">
            <div class="card-body">
                <div class="row mt-3">
                    <div class="col-md-3">
                        <div class="form-group">
                            <label for="VendorDisplayProperty">{{ l('Customer') }}</label>
                            <app-search-customer (customerEvent)="getCustomer($event)" [customerSelectedItem]="this.customerSelectedItem"> </app-search-customer>
                        </div>
                    </div>
                    <div class="col-md-2">
                        <div class="form-group">
                            <label for="salesInvoice_PDate">{{ l('PDate') }}</label>

                            <abp-datetime-picker #salesInvoice_date="ngModel" [(ngModel)]="salesInvoice.date"
                                                 id="salesInvoice_date" name="salesInvoice_date"
                                                 [bsConfig]="{ adaptivePosition: true }"></abp-datetime-picker>

                            <validation-messages [formCtrl]="salesInvoice_date"></validation-messages>
                        </div>
                    </div>
                    <div class="col-md-2">
                        <div class="form-group">
                            <label for="salesInvoice_ReferenceNo">{{ l('ReferenceNo') }}</label>
                            <input type="text" #salesInvoice_ReferenceNo="ngModel" id="salesInvoice_ReferenceNo"
                                   class="form-control" [(ngModel)]="salesInvoice.referenceNo" name="ReferenceNo" />
                            <validation-messages [formCtrl]="salesInvoice_ReferenceNo"></validation-messages>
                        </div>
                    </div>
                    <div class="col-md-2">
                        <div class="form-group m-form__group">
                            <label for="PaymentTermName">{{ l('PaymentTerm') }}</label>
                            <select name="salesInvoice.paymentTermId" [(ngModel)]="salesInvoice.paymentTermId"
                                    class="form-select">
                                <option value="">{{ l('SelectAPaymentTerm') }}</option>

                                <option *ngFor="let item of allPaymentTerms" value="{{ item.id }}">
                                    {{ item.displayName }}
                                </option>
                            </select>
                        </div>
                    </div>
                    <div class="col-md-2">
                        <div class="form-group">
                            <label for="salesInvoice_TaxType">{{ l('TaxType') }}</label>
                            <select #salesInvoice_TaxType="ngModel" class="form-select" name="TaxType" (change)="calculateTotalValues()"
                                    id="salesInvoice_TaxType" [(ngModel)]="salesInvoice.taxType">
                                <option value="1">{{ l('Normal') }}</option>

                                <option value="2">{{ l('Inclusive') }}</option>
                            </select>
                            <validation-messages [formCtrl]="salesInvoice_TaxType"></validation-messages>
                        </div>
                    </div>
                   
                </div>
                <div class="row mt-3">
                    <div class="col-md-12">
                        <table class="table table-bordered">
                            <thead>
                                <tr>
                                    <th width="5%">#</th>
                                    <th width="10%">{{ l('ItemCode') }}</th>
                                    <th width="30%">{{ l('ItemName') }}</th>
                                    <th width="8%">{{ l('Qty') }}</th>
                                    <th width="8%">{{ l('UOM') }}</th>
                                    <th width="8%">{{ l('Price') }}</th>
                                    <th width="8%">{{ l('FocQty') }}</th>
                                    <th width="8%">{{ l('DiscAmtPer') }}</th>
                                    <th width="8%">{{ l('DiscAmount') }}</th>
                                    <th width="10%">{{ l('Tax') }}</th>
                                    <th width="10%">{{ l('Total') }}</th>
                                    <th width="5%">{{ l('Action') }}</th>
                                </tr>
                            </thead>
                            <tbody>

                                <tr *ngFor="let data of purchaseDetails; let i = index">
                                    <td class="text-center">
                                        <div class="d-flex align-items-center">
                                            <button class="btn btn-danger d-flex align-items-center justify-content-center p-0 rounded-circle"
                                                    style="width: 30px; height: 30px" (click)="removeItem(i)">
                                                x
                                            </button>
                                            <span class="ps-1"><b>{{ data.slNo }}</b></span>
                                        </div>
                                        <!-- (click)="removeItem(i)" -->
                                    </td>
                                    <td> <input type="text" #itemCodeInput class="form-control" [(ngModel)]="data.productCode" (keydown.enter)="searchProduct(data.productCode,data,i)" (blur)="searchProduct(data.productCode,data,i)" /> </td>
                                    <td>
                                        <app-search-product (productEvent)="getProduct($event,data,i)" [productSelectedItem]="data.productSelectedItem"> </app-search-product>
                                    </td>
                                    <td><input type="text" #qtyInput (keydown.enter)="focusNext('price', i)" class="form-control text-end" appAllowDecimal [(ngModel)]="data.qty" (ngModelChange)="amountCalculate(data)" /></td>
                                    <td>
                                        <a *ngIf="!data.changeUnitFlag" (click)="changeUnit(data)"><span><b> {{data.unitName}} </b> </span> </a>
                                        <select name="data.unitId" *ngIf="data.changeUnitFlag"
                                                [(ngModel)]="data.unitId"
                                                class="form-select"
                                                required>

                                            <option *ngFor="let item of data.applicableUnits" value="{{ item.unitId }}">
                                                {{ item.name }}
                                            </option>
                                        </select>
                                    </td>
                                    <td><input type="text" #costInput (keydown.enter)="focusNext('focQty', i)" class="form-control text-end" appAllowDecimal [(ngModel)]="data.price" (ngModelChange)="amountCalculate(data)" /></td>
                                    <td><input type="text" #focQtyInput (keydown.enter)="focusNext('itemDiscountPerc', i)" class="form-control text-end" appAllowDecimal [(ngModel)]="data.focQty" /></td>
                                    <td><input type="text" #itemDiscountPercInput (keydown.enter)="focusNext('itemDiscount', i)" class="form-control text-end" appAllowDecimal [(ngModel)]="data.itemDiscountPerc" (ngModelChange)="amountCalculate(data)" /></td>
                                    <td><input type="text" #itemDiscountInput (keydown.enter)="focusNext('tax', i)" class="form-control text-end" appAllowDecimal [(ngModel)]="data.itemDiscount" (ngModelChange)="amountCalculate(data)" /></td>
                                    <td>
                                        <select name="data.taxId" #taxInput (change)="amountCalculate(data)" (keydown.enter)="focusNext('add', i)"
                                                [(ngModel)]="data.taxId"
                                                class="form-select">
                                            <option value="null">{{ l('None') }}</option>
                                            <option *ngFor="let item of applicableTaxes" value="{{ item.id }}">
                                                {{ item.name }}
                                            </option>
                                        </select>
                                    </td>
                                    <td><b>{{data.totalValue | priceFormat}}</b></td>
                                    <td width="5%" class="text-center">
                                        <button #addButton (keydown.enter)="focusNext('nextRow', i)" class="btn btn-success d-flex align-items-center justify-content-center p-0 rounded-circle"
                                                style="width: 30px; height: 30px" (click)="addRow(i)">
                                            +
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <table>
                            <tr>
                                <td width="80%" style="vertical-align: top">
                                    <div class="row" style="margin-right:8px;">
                                        <div class="col-md-8">&nbsp;&nbsp;</div>
                                        <div class="col-md-2">
                                            <div class="form-group">
                                                <label for="salesInvoice_PTotalValue">{{ l('PTotalValue') }}</label>
                                                <input type="number" readonly="readonly"
                                                       priceFormat
                                                       id="salesInvoice_PTotalValue" class="form-control text-end"
                                                       [(ngModel)]="salesInvoice.totalValue" name="PTotalValue" />
                                            </div>
                                        </div>

                                        <div class="col-md-2">
                                            <div class="form-group">
                                                <label for="salesInvoice_PNetDiscountPerc">
                                                    {{ l('PNetDiscountPerc') }}
                                                </label>
                                                <input type="text" appAllowDecimal id="salesInvoice_PNetDiscountPerc" class="form-control text-end"
                                                       [(ngModel)]="salesInvoice.netDiscountPerc"
                                                       name="PNetDiscountPerc" (ngModelChange)="calculateTotalValues()" />
                                            </div>
                                        </div>
                                        <div class="col-md-12">
                                            <div class="form-group">
                                                <label for="salesInvoice_Remarks">{{ l('Remarks') }}</label>
                                                <input type="text"
                                                       id="salesInvoice_Remarks" class="form-control"
                                                       [(ngModel)]="salesInvoice.remarks" name="Remarks" />

                                            </div>
                                        </div>
                                        <div class="col-md-2">
                                            &nbsp;
                                        </div>
                                        <div class="col-md-6">&nbsp;&nbsp;</div>
                                        <div class="col-md-2">
                                            <div class="form-group">
                                                <label for="salesInvoice_OtherCharges">{{ l('OtherCharges') }}</label>
                                                <input type="text" appAllowDecimal id="salesInvoice_OtherCharges" class="form-control text-end"
                                                       [(ngModel)]="salesInvoice.otherCharges" name="OtherCharges"
                                                       (ngModelChange)="calculateTotalValues()" />
                                            </div>
                                        </div>
                                        <div class="col-md-2">
                                            <div class="form-group">
                                                <label for="salesInvoice_PRoundingAmount">
                                                    {{ l('PRoundingAmount') }}
                                                </label>
                                                <input type="text" appAllowDecimal id="salesInvoice_PRoundingAmount" class="form-control text-end"
                                                       [(ngModel)]="salesInvoice.roundingAmount"
                                                       name="PRoundingAmount" (ngModelChange)="calculateTotalValues()" />
                                            </div>
                                        </div>
                                    </div>
                                </td>
                                <td width="20%" style="vertical-align: top">
                                    <div class="row">
                                        <div class="col-md-12">
                                            <div class="form-group">
                                                <label for="salesInvoice_PSubTotal">{{ l('PSubTotal') }}</label>
                                                <input type="number" readonly="readonly"
                                                       id="salesInvoice_PSubTotal" class="form-control text-end"
                                                       [(ngModel)]="salesInvoice.subTotal" name="PSubTotal" />

                                            </div>
                                        </div>
                                        <div class="col-md-12">
                                            <div class="form-group">
                                                <label for="salesInvoice_PTax">{{ l('PTax') }}</label>
                                                <input type="number"
                                                       id="salesInvoice_PTax" class="form-control text-end"
                                                       [(ngModel)]="salesInvoice.tax" name="PTax" readonly="readonly" />
                                            </div>
                                        </div>
                                        <div class="col-md-12">
                                            <div class="form-group">
                                                <label for="salesInvoice_PGrandTotal">{{ l('PGrandTotal') }}</label>
                                                <input type="number"
                                                       id="salesInvoice_PGrandTotal" class="form-control text-end"
                                                       [(ngModel)]="salesInvoice.grandTotal" name="PGrandTotal" readonly="readonly" />
                                            </div>
                                        </div>
                                        <div class="col-md-12">
                                            <div class="form-group">
                                                <label for="salesInvoice_PNetTotal">{{ l('PNetTotal') }}</label>
                                                <input type="number"
                                                       id="salesInvoice_PNetTotal" class="form-control text-end"
                                                       [(ngModel)]="salesInvoice.netTotal" name="PNetTotal" readonly="readonly" />

                                            </div>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </table>
                    </div>
                </div>
            </div>
            <div class="card-footer">
                <div class="col-lg-12 text-end">
                    <button (click)="goBack()" class="btn btn-danger me-2" [buttonBusy]="saving">
                        <i class="fa fa-close"></i>
                        <span>{{ l('Close') }}</span>
                    </button>
                    <button (click)="save(status.Draft)" class="btn btn-primary blue me-2" [buttonBusy]="saving"
                            [busyText]="l('SavingWithThreeDot')" *ngIf="salesInvoice.status == status.Draft">
                        <i class="fa fa-save"></i>
                        <span>{{ l('SaveAsDraft') }}</span>
                    </button>

                    <button (click)="save(status.Invoiced)" *ngIf="salesInvoice.id == null"
                            class="btn btn-primary blue float-right" [buttonBusy]="saving"
                            [busyText]="l('SavingWithThreeDot')">
                        <i class="fa fa-save"></i>
                        <span>{{ l('Save') }}</span>
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>
